export const Constants = {
  TAG_NAME: 'pop-literature-table-component',
  LITERATURE: 'Literature',
  DOWNLOAD: 'Download',
  EMAIL: 'Email',
  BLANK: '_blank',
  LITERATURE_UNAVAILABLE: 'Literature unavailable',
  HASH_LITERATURE: '#literature',
  EMAIL_SUBJECT_TEXT: 'Check out this T. Rowe Price product literature',
  BEGINNING_EMAIL_BODY_TEXT: 'I thought you might find this T. Rowe Price ',
  ENDING_EMAIL_BODY_TEXT:
    'interesting. Click on the link below or copy and paste it in a browser to view the page.',
  ICON_SLOT: 'icon',
  LOCKED_MESSAGE: 'Sign in or register to access',
} as const;
